module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_2_2.f6bbe2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_2_2.png
// module id = GAxs
// module chunks = 0